import React from 'react';
import classNames from 'classnames';

import './index.scss';

export default function DisapprovalXMark({inverted, size = 30}) {
    const classes = classNames('disapproval-x-mark', {
        'disapproval-x-mark--inverted': inverted
    });
    return <div className={classes} style={{width: size, height: size}} />;
}



// WEBPACK FOOTER //
// ./components/disapproval_x_mark/index.js